import { render } from "./AddEventRecap.vue?vue&type=template&id=48d03898"
import script from "./AddEventRecap.vue?vue&type=script&lang=js"
export * from "./AddEventRecap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__